import React, { useRef, useEffect } from "react";
import config from "../../../../../config.js";
import {
  SaveDemDxLogsAndSummary,
  setDemDxSummary,
  setIsDemDxActive,
  setDemDxSummaryText,
  GetPatientVitalsSummaryByPatientId,
  getPatientVitals,
} from "../../../../../dispatchers/patientDispatchers.js";
import generateSummary from "../../../../../utils/SummaryCreation.js";
import { encryptData, decryptData } from "../../../../../utils/jweService.js";

export default function PatientDemDxIframe({
  isDemDXTemplate,
  stopTranscription,
  ConsultationId,
}) {
  const { dexDxUrl, demDxIssuer } = config;
  const iframeRef = useRef(null);
  const hasPosted = useRef(false);

  useEffect(() => {
    async function handleReady(event) {
      if (event.origin !== dexDxUrl) return;
      if (typeof event.data === "object" && event.data !== null) {
        const { type, ...data } = event.data;
        switch (type) {
          case "demdxConnectionReady":
            if (
              isDemDXTemplate &&
              iframeRef.current?.contentWindow &&
              !hasPosted.current
            ) {
              hasPosted.current = true;
              iframeRef.current.contentWindow.postMessage(
                await encryptData({ data: isDemDXTemplate }),
                dexDxUrl
              );
            }
            break;
          case "demdxSendPayload":
            const decrypted = await decryptData({ token: data.data.token });
            setDemDxSummary(decrypted?.data);
            setDemDxSummaryText(generateSummary(decrypted?.data));
            setIsDemDxActive(false);
            await SaveDemDxLogsAndSummary(decrypted?.data);
            await getPatientVitals(decrypted?.data?.patientId);
            await GetPatientVitalsSummaryByPatientId(
              decrypted?.data?.patientId
            );
            stopTranscription();
            window.removeEventListener("message", handleReady);
            break;
          default:
            break;
        }
      }
    }

    window.addEventListener("message", handleReady);

    return () => {
      window.removeEventListener("message", handleReady);
      hasPosted.current = false;
    };
  }, [isDemDXTemplate, dexDxUrl]);

  return (
    <iframe
      id="DemDx"
      title="DemDx"
      ref={iframeRef}
      src={`${dexDxUrl}${demDxIssuer}`}
      allow="clipboard-read; clipboard-write"
      style={{ width: "100%", height: "600px", border: "none" }}
    />
  );
}
